<!-- <app-ng-dynamic-breadcrumb
  [symbol]="'>'"
  [bgColor]="'transparent'"
  [fontSize]="'15px'"
  [fontColor]="'#161c24'"
  [lastLinkColor]="'#323639'"
>
</app-ng-dynamic-breadcrumb> -->

<div class="reports-page">

  <!-- Tab Navigation -->
  <ul class="nav reports-tabs" role="tablist">
    <li class="reports-tab-item">
      <a href="javascript:void(0)" class="reports-tab-link" [class.active]="activeTab === 'individual'"
        (click)="setActiveTab('individual')" role="tab">
        <ion-icon name="person-outline"></ion-icon>
        <span>Individual Winner</span>
      </a>
    </li>

    <li class="reports-tab-item">
      <a href="javascript:void(0)" class="reports-tab-link" [class.active]="activeTab === 'individualBatch'"
        (click)="setActiveTab('individualBatch')" role="tab">
        <ion-icon name="people-outline"></ion-icon>
        <span>Individual Batch Winner</span>
      </a>
    </li>

    <li class="reports-tab-item">
      <a href="javascript:void(0)" class="reports-tab-link" [class.active]="activeTab === 'bulk'"
        (click)="setActiveTab('bulk')" role="tab">
        <ion-icon name="cube-outline"></ion-icon>
        <span>Bulk Winner</span>
      </a>
    </li>
  </ul>

  <!-- Tab Panels -->
  <div class="reports-tab-content">

    <!-- Individual Winner Panel -->
    <div class="reports-tab-pane" [class.active]="activeTab === 'individual'">
      <div class="auction-content-body position-relative">
        <div class="card auction-content-main m-0 p-3">
          <div class="panel-heading">
            <h3 class="fs-lg">Individual winner</h3>
          </div>
          <div class="table-responsive auto-scroll">
            <table datatable class="auction-dt table table-striped individual-report-table content"
              id="individual-report" [dtOptions]="dtIndividualOptions">
              <thead class="sticky-hdr">
                <tr>
                  <th *ngFor="let thead of theadsIndividuals">{{ thead }}</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Individual Batch Winner Panel -->
    <div class="reports-tab-pane" [class.active]="activeTab === 'individualBatch'">
      <div class="auction-content-body position-relative">
        <div class="card auction-content-main m-0 p-3">
          <div class="panel-heading">
            <h3 class="fs-lg">Individual batch winner</h3>
          </div>

          <div class="table-responsive" *ngIf="individualBatchAuctions.length; else fallback">
            <table datatable class="auction-dt table table-striped" [dtOptions]="dtOptions">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Title</th>
                  <th scope="col">Type</th>
                  <th scope="col">Winner</th>
                  <th scope="col">Highest bid</th>
                  <th scope="col">Location</th>
                  <th scope="col" style="text-align: center">
                    Approve Status
                    <button type="button" class="tooltip-btn"
                      tooltip="This is the auction status; it indicates whether or not the auction requires admin approval."
                      placement="bottom">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                    </button>
                  </th>
                  <th scope="col" style="text-align: center">
                    Payment Status
                    <button type="button" class="tooltip-btn"
                      tooltip="This status indicates if the proof of payment document was accepted or not by admin."
                      placement="bottom">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-question-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                        <path
                          d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />
                      </svg>
                    </button>
                  </th>
                  <th scope="col">View</th>
                </tr>
              </thead>

              <tbody>
                <ng-container *ngFor="let winner of individualBatchAuctions">
                  <tr>
                    <td>
                      <div class="auction-dt-tableImage">
                        <img src="{{ '' || userFallBackImg }}" alt="" style="height: 50px; width: 50px" />
                      </div>
                    </td>
                    <td>{{ winner['auction_information']?.[0]?.['title']}}</td>

                    <td>
                      {{ (winner['auction_information']?.[0]?.['entity_type'] | removeUnderscore ) | titlecase }}
                    </td>
                    <td>
                      {{ winner?.['user_details']?.['first_name'] + ' ' + winner?.['user_details']?.['last_name'] }}
                    </td>
                    <td>
                      {{ winner["winning_bid_amount"] | number: "1.0":"en-US" }}
                    </td>

                    <td>
                      {{ winner['auction_information']?.[0]?.['location'] || 'N/A' }}
                    </td>
                    <td style="text-align: center">
                      <div class="auction-dt-tableTool"
                        *ngIf="winner['auction_information']?.[0]?.['admin'] === true; else notRequired">
                        <div *ngIf="checkingValue.includes(winner['auction_information']?.[0]?.['approval'])">
                          <button type="button" class="btn curved green smallBtn px-4 mr-1"
                            *ngIf="winner['auction_information']?.[0]?.['approval'] === true || winner['auction_information']?.[0]?.['approval'] === null"
                            [disabled]="winner['auction_information']?.[0]?.['approval']"
                            (click)="updateStatus(winner['auction_id'], '1')">
                            {{
                            winner['auction_information']?.[0]?.['approval'] ? 'Approved': 'Approve'}}
                          </button>
                          <button type="button" class="btn curved red smallBtn px-4"
                            *ngIf="winner['auction_information']?.[0]?.['approval'] === false || winner['auction_information']?.[0]?.['approval'] === null"
                            [disabled]="winner['auction_information']?.[0]?.['approval'] === false"
                            (click)="updateStatus(winner['auction_id'], '0')">
                            {{
                            winner['auction_information']?.[0]?.['approval'] === false ? 'Rejected': 'Reject'}}
                          </button>
                        </div>
                      </div>
                      <ng-template #notRequired>
                        <button type="button" class="btn curved yellow smallBtn px-4 mr-1" disabled>
                          Not Require
                        </button>
                      </ng-template>
                    </td>
                    <td style="text-align: center">
                      <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === null">
                        <div class="d-flex align-items-center justify-content-center">
                          <img class="paymentIcons" src="{{ env + 'assets/img/pending-clock-icon.png' }}" />
                          <p class="ml-2">Pending</p>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === true">
                        <div class="d-flex align-items-center justify-content-center">
                          <img class="paymentIcons" src="{{ env + 'assets/img/checkmark-flat.svg' }}" />
                          <p class="ml-2">Approved</p>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="winner['auction_information']?.[0]?.['payment'] === false">
                        <div class="d-flex align-items-center justify-content-center">
                          <img class="paymentIcons" src="{{ env + 'assets/img/red-x-icon.png' }}" />
                          <p class="ml-2">Rejected</p>
                        </div>
                      </ng-container>
                    </td>
                    <td>
                      <a [routerLink]="['/auction-details', winner['auction_id']]" class="auction-bidders">
                        <ion-icon name="eye" class="ion-lg color-yellow"></ion-icon>
                      </a>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <ng-template #fallback>
            <div class="empty-state">
              <ion-icon name="document-text-outline"></ion-icon>
              <h3>No reports found</h3>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- Bulk Winner Panel -->
    <div class="reports-tab-pane" [class.active]="activeTab === 'bulk'">
      <div class="auction-content-body position-relative">
        <div class="card auction-content-main m-0 p-3">
          <div class="panel-heading">
            <h3 class="fs-lg">Bulk winner</h3>
          </div>
          <div class="table-responsive auto-scroll">
            <table datatable class="auction-dt table table-striped bulk-report-table" id="bulk-report"
              [dtOptions]="dtBulkOptions">
              <thead class="sticky-hdr">
                <tr>
                  <th *ngFor="let thead of theadsBulk">{{ thead }}</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- <app-loader
  *ngIf="
    (loadingService.individualLoading$ | async) ||
    (loadingService.bulkLoading$ | async)
  "
></app-loader> -->